var cookie = {
    set:function(key,val){
        var date=new Date();
        var expiresDays=365;
        date.setTime(date.getTime()+expiresDays*24*3600);
        document.cookie=key + "=" + val +";expires="+date.toGMTString()+";path=/";
    },
    get:function(key){
        var getCookie = document.cookie.replace(/[ ]/g,"");
        var arrCookie = getCookie.split(";")
        var tips;
        for(var i=0;i<arrCookie.length;i++){
            var arr=arrCookie[i].split("=");
            if(key==arr[0]){
                tips=arr[1];
                break;
            }
        }
        return tips;
    },
    delete:function(key){
        var date=new Date();
        var expiresDays=-1;
        date.setTime(date.getTime()+expiresDays*24*3600);
        document.cookie=key + "=" + '' +";expires="+date.toGMTString()+";path=/";
    }
}

function setStorage(key, value) {
    localStorage.setItem(key,value);
    cookie.set(key,value);
}

function getStorage(key) {
    let storage;
    if(localStorage.getItem(key) != ''){
        storage = localStorage.getItem(key);
        return storage;
    } else{
        storage = cookie.get(key);
        return storage;
    }
}

function deleteStorage(key) {
    localStorage.removeItem(key);
    cookie.delete(key);
}

export {
    setStorage,
    getStorage,
    deleteStorage
}


// WEBPACK FOOTER //
// ./src/alias/store.js